var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.25 31.25V39.5833C44.25 40.6884 43.811 41.7482 43.0296 42.5296C42.2482 43.311 41.1884 43.75 40.0833 43.75H10.9167C9.8116 43.75 8.75179 43.311 7.97039 42.5296C7.18899 41.7482 6.75 40.6884 6.75 39.5833V31.25",
    stroke: "#FFF3E2",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0834 20.8333L25.5 31.2499L35.9167 20.8333",
    stroke: "#FFF3E2",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 31.25V6.25",
    stroke: "#FFF3E2",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiDownload);
export default __webpack_public_path__ + "static/media/fi_download.6c8c083203a3985844ad4221a728aec7.svg";
export { ForwardRef as ReactComponent };